import moment from 'dayjs'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { Location } from 'components/BillingLocationSelector'

import * as ls from 'local-storage'
import Api from "../api";
import {useHistory} from "react-router";
import {usePersistedApi, usePersistedState} from "../hooks";
import entities from "../reduxStore/entityKeys";
import { HygienistRole, RELIABILITY_STATUSES, roles } from "./constants";
import { OfferHygienist, SkillsProps, HygienistProps } from "./types";

moment.extend(utc);
moment.extend(timezone);
moment.extend(customParseFormat);

const mainView = (window as any).mainView
// @ts-ignore
const app = window.app;
const TempStars = (window as any).TempStars

export const hexWithAlpha = (hexColor: string, alpha: number) => {
	const rgb =
		(hexColor.match(/#(..)(..)(..)/) as any)
			.slice(1)
			.map((a: any) => Number.parseInt(a, 16))
			.join(', ')
	return `rgba(${rgb}, ${alpha})`
}

export const formatPrice = (price: number) => {
	return `$${(price / 100).toFixed(2)}`
}

export const getEnumKeys = (en: any) => {
	return Object
		.keys(en)
		.filter(k => typeof en[k as any] === 'number') as Array<string>
}

export const getEnumValues = (en: any) => {
	return getEnumKeys(en)
		.map(k => en[k as any]) as Array<number>
}

export const exitReactStyles = () => {
	const react = document.getElementById('react')
	const noReact = document.getElementById('noReact')
	// @ts-ignore
	react.style.display = 'none'
	// @ts-ignore
	noReact.style.display = 'block'

	window.removeEventListener('storage', () => {
		ls.remove('pageData')
	})
}

export const exitReact = (page?: string | null, props?: any, direction?: 'fwd' | 'bwd' | 'rld', data?: any) => {
	try {
		const userAccount: {
			hygienistId: number | null,
			dentistId: number | null
		} = ls.get('userAccount') || {}

		if (page) {
			if (Number.isInteger(userAccount?.hygienistId)) {
				if (direction === 'rld') {
					TempStars.Hygienist.Router.reloadPage(page, props)
				} else {
					direction === 'fwd' ? TempStars.Hygienist.Router.goForwardPage(page, props, data)
						: TempStars.Hygienist.Router.goBackPage(page, props)
				}
			} else if (Number.isInteger(userAccount?.dentistId)) {
				if (direction === 'rld') {
					TempStars.Dentist.Router.reloadPage(page, props)
				} else {
					direction === 'fwd' ? eval(`TempStars.Dentist.Router.goForwardPage(page, props)`)
						: TempStars.Dentist.Router.goBackPage(page, props)
				}
			} else {
				eval(`mainView.router.loadPage( {url: page, animatePages: false} )`);
			}
		} else {
			eval(`mainView.router.loadPage( {url: 'index.html', animatePages: false} )`);
		}
	} catch (e: any) {
		console.log(e);
	}
	exitReactStyles()
}

export const navigateToCordovaLocationsScreen = () => {
	try {
		eval(`TempStars.Dentist.Router.goForwardPage('locations-add-step1')`)
	} catch {
	}
}

export const navigateToCordovaPaymentInfoScreen = (location: Location) => {
	try {
		eval(`TempStars.Dentist.Router.goForwardPage('payment-info', { locationId: ${location.id} });`)
	} catch {
	}
}

export const mapJobTypeToPosition = (jobType: number): string => {
	return [
		'Hygienist',
		'Dental Assistant',
		'Admin/Front Desk',
		'Associate Dentist',
	][jobType]
}

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const formatDate = (date: Date | string, fmt = 'MMMM DD, YYYY', timeZone?: string) => {
	if (date) {
	  const parsedDate = dayjs.utc(date);
	  
	  if (!parsedDate.isValid()) {
		console.error('Invalid date input:', date);
		return '';
	  }
  
	  if (timeZone) {
		return parsedDate.tz(timeZone, true).format(fmt);
	  }
	  
	  return parsedDate.format(fmt);
	}
	return '';
  };

export const getDaysFromDate = (date: Date | string): number => {
	const diff = new Date().getTime() - new Date(date).getTime();
	return Math.round(diff / 86400000)
}

export const formatDateBackend = (date: Date) => {
	if (!date) {
		return null as any
	}
	return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export const formatAvailabilityToNames = (availability: string | Array<string>) => {
	if (typeof availability === 'string') {
		availability = availability.split(',')
	}
	const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
	let resultDays: string[] = []
	availability.forEach((day, index) => {
		if (day === '1') {
			return resultDays.push(days[index])
		}
	})
	return resultDays.join(', ')
}

export const formatCertificates = (isOrtho ?: boolean, isRestorative ?: boolean): string => {
	let result = []
	if (isOrtho) {
		result.push('Orthodontic')
	}
	if (isRestorative) {
		result.push('Restorative')
	}
	return result.join(' & ')
}

export const formatCityProvince = (city: string, province: string): string => {
	return `${city}, ${province}`
}

export const formatFullLocation = (location?: Location): string => {
	return [location?.address, location?.city, location?.province].filter(Boolean).join(', ');
}

export const mimeTypeToExtension = (type: string): string => {
	switch (type) {
		case 'application/msword':
			return 'doc';
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			return 'docx';
		case 'application/pdf':
			return 'pdf';
		case 'application/rtf':
		case 'text/richtext':
			return 'rtf';
		case 'text/plain':
			return 'txt';
		case 'image/jpeg':
		case 'image/jpg':
			return 'jpg';
		case 'image/gif':
			return 'gif';
		case 'image/png':
			return 'png';
		case 'text/calendar':
			return 'ics';
		default:
			return '';
	}
};

export const login = async ( email: string, password: string, setUser: (value: any) => any ) => {
	TempStars.User.userLoggedIn = false;
	TempStars.User.userAccount = undefined;
	ls.remove('userAuth');
	ls.remove('userAccount');
	ls.remove('skillsModalSeen');
	try {
		const auth = await Api.login( email, password );
		let userAuth = {
			jwtToken: auth.token
		};
		ls.set('userAuth', userAuth);
		TempStars.Api.setAuthJwtToken(auth.token);
		await Api.updateToken()
		const user = await Api.getUser();
		setUser(user)
		TempStars.User.setCurrentUser(user);
		ls.set( 'userAccount', user );
		if ( auth.isAgent ) {
			TempStars.Analytics.track('Support Agent Logged In')
			ls.set( 'isAgent', auth.isAgent );
		}
		TempStars.User.setUserLoggedIn(true);
		await TempStars.Push.init();
		await TempStars.User.setUserAnalytics(user)
		await TempStars.Conversations.getUserChatAccessToken(true)
		await TempStars.Conversations.createConversationClient()
		return user;
	} catch (e: any) {
		TempStars.Logging.log('login failed for: ' + email );
		throw e;
	}
}

export const checkIsSetupComplete = (userAccount: any) => {
	if ( ! userAccount ) {
		return false;
	}

	return userAccount.hygienist && userAccount.hygienist.isComplete ||
		userAccount.dentist && userAccount.locations;
}

export const sendResume = async (resumeSrc: string, resumeUrl: any, userId: number, errorMessage: any, setErrorMessage: any) => {
	const file = resumeUrl.files[0];
	const ext = mimeTypeToExtension(file.type)

	const dotIndex = file.name.lastIndexOf('.');
	if ( dotIndex != -1 && file.name.length > dotIndex ) {
		console.log('File extension is OK')
	} else {
		setErrorMessage({...errorMessage, resume: 'Resume Error. Please change or remove file'})
	}
	try {
		const blob = TempStars.File.convertDataURItoBlobSync( resumeSrc );
		const result = await TempStars.Api.getAwsUploadCredentials(file.type, userId + '.' + ext);
		await TempStars.Ajax.upload(result.signedRequest, blob, { contentType: file.type })
		return result.url;
	} catch (e: any) {
		return setErrorMessage({...errorMessage, resume: e?.message || 'Error'})
	}
}

export const uploadPhoto = async (imageSrc: string, photoUrl: any, userId: number, errorMessage: any, setErrorMessage: any) => {
	const file = photoUrl.files[0];
	const ext = mimeTypeToExtension(file.type)
	if (!ext.length) {
		setErrorMessage({...errorMessage, photo: 'unknown image type'})
	}

	try {
		const blob = TempStars.File.convertDataURItoBlobSync(imageSrc);
		const result = await TempStars.Api.getAwsUploadCredentials(file.type, userId + '.' + ext)
		await TempStars.Ajax.upload(result.signedRequest, blob, {contentType: file.type})
		return result.url
	} catch (e: any) {
		return setErrorMessage({...errorMessage, photo: 'unknown image type'})
	}
}

export const addUniqueToArray = (array: any[], array2: any[]) => {
	const arrSet = new Set([...array, ...array2]);
	return Array.from(arrSet)
}

export const getTypeByRoleNumber = (roleNumber: number) => {
	let type;
	switch (roleNumber) {
		case roles.ADMIN: //ADMIN
			type = 2; //ADMIN
			break;
		case roles.ASSISTANT://ASSISTANT
			type = 1 //ASSISTANT
			break;
		case roles.FRONT_DESK: //FRONT_DESK
			type = 2; //FRONT_DESK
			break;
		case roles.ASSOCIATE_DENTIST: //ASSOCIATE_DENTIST
			type = 3; //ASSOCIATE_DENTIST
			break;
		default:
			type = 0; //HYGIENIST
	}
	return type;
}

type HygienistType = HygienistProps['type'];
export function getRoleByTypeNumber(typeNumber: HygienistType): HygienistRole {
	let role: HygienistRole;
	switch (typeNumber) {
		case 2: //ADMIN
			role = roles.FRONT_DESK; //ADMIN/FRONT_DESK?
			break;
		case 1://ASSISTANT
			role = roles.ASSISTANT //ASSISTANT
			break;
		case 3: //ASSOCIATE_DENTIST
			role = roles.ASSOCIATE_DENTIST; //ASSOCIATE_DENTIST
			break;
		default:
			role = roles.HYGIENIST; //HYGIENIST
	}
	return role;
}

export const formatProfileHygienistName = (hygienist: OfferHygienist, skills: SkillsProps[]) => {
	let html;
	let qualificationSkill = skills?.find(skill => skill.qualification === 1)
	if (qualificationSkill) {
		html = `${hygienist.firstName} ${hygienist.lastName}, ${qualificationSkill.name}`;
	} else {
		qualificationSkill = skills?.find(skill => skill.license === 1)
	}

	if (qualificationSkill) {
		html = `${hygienist.firstName} ${hygienist.lastName}, ${qualificationSkill.name === 'HFTDA' || qualificationSkill.name === 'NHFTDA' ? qualificationSkill.label : qualificationSkill.name}`;
	} else if (hygienist.type === 0) {
		html = `${hygienist.firstName} ${hygienist.lastName}, RDH`;
	} else if (hygienist.type === 1) {
		html = `${hygienist.firstName} ${hygienist.lastName}, DA`;
	}
	return html;
}

export const getPaymentTerms = (paymentTerms:number) => {
	if(paymentTerms===1) return 'Within 24h'
	if(paymentTerms===14) return 'Within 2 weeks'
	if(paymentTerms===30) return 'Within a month'
}

export const getPaymentMethod = (paymentMethod: number, country: number) => {
	if(paymentMethod===1) return 'Pay Now (TempStars\'s Payment Processor)'
	if(paymentMethod===2) return country === 0 ? 'Cheque' : 'Check'
	if(paymentMethod===3) return 'Electronic Funds Transfer'
	if(paymentMethod===4) return 'Payroll / Temporary Employee'
}

export const getPaymentType = (payType: number) => {
	if(payType===0) return '1099 Independent Contractor'
	if(payType===1) return 'W2'
	if(payType===2) return 'Either 1099 Independent Contractor or W2'
}

export const getReliabilityStatus = (score: number) => {
	if(score > 0.9 ) return RELIABILITY_STATUSES['90']
	if(score > 0.8 ) return RELIABILITY_STATUSES['80']
	if(score > 0.7 ) return RELIABILITY_STATUSES['70']
	if(score > 0.6 ) return RELIABILITY_STATUSES['60']
	return RELIABILITY_STATUSES['50']
}

export const getReliabilityStatusObject = (score: number) => {
	if(score > 0.9 ) return { title: 'Outstanding', position: '10', color: '#13CA82' }
	if(score > 0.8 ) return { title: 'Very Good', position: '20', color: '#0B4598' }
	if(score > 0.7 ) return { title: 'Good', position: '30', color: '#FF9800' }
	if(score > 0.6 ) return { title: 'Fair', position: '40', color: '#EF6C00' }
	return { title: 'Below Average', position: '50', color: '#FB7672' }
}

export const formatErrorMessage = (error: any) => {
	try {
		return JSON.parse(error?.message)?.message
	} catch (e) {
		return error?.message
	}
}